import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import NavbarMenu from './components/NavbarMenu';
import { getUserProfileApi } from './api/userApi';
import { setUserProfile } from './actions';
import { toast } from 'sonner';

const App = (props) => {
  const [isLoad, setIsLoad] = useState(true);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const navigate = useNavigate();

  const res = window.location.pathname;
  let baseUrl = process.env.REACT_APP_PUBLIC_URL;

  // Remove protocol and domain part from baseUrl
  baseUrl = new URL(baseUrl).pathname;

  // Split the baseUrl and current path
  const baseUrlParts = baseUrl.split('/').filter(Boolean);
  const pathParts = res.split('/').filter(Boolean);

  // Calculate activeKey1 based on the length of baseUrlParts
  let activeKey1 =
    pathParts.length > baseUrlParts.length
      ? pathParts[baseUrlParts.length]
      : '/';

  // Ensure activeKey1 is not empty
  activeKey1 = activeKey1 ? activeKey1 : '/';

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login'); // Navigate to /login if not logged in
    }
  }, [activeKey1]);

  const isLoggedin = useSelector((state) => state.loginReducer.isLoggedin);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        if (isLoggedin) {
          const response = await getUserProfileApi();
          dispatch(setUserProfile(response.data));
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
        if (
          error.response.data &&
          error.response.data.error.name === 'TokenExpiredError'
        ) {
          toast.error('Session Expired. Please login again');
        } else {
          toast.error('Error fetching user profile! Please login again');
        }
        localStorage.clear();
        navigate('/login');
      }
    };

    fetchUserProfile();
  }, [dispatch, isLoggedin]);

  useEffect(() => {
    const themeBlushElement = document.querySelector('.theme-blush');
    if (themeBlushElement) {
      themeBlushElement.style.marginLeft = isSidebarVisible ? '50px' : '00px';
    }
  }, [isSidebarVisible]);

  return (
    <div id="wrapper">
      <NavbarMenu
        history={props.history}
        activeKey={activeKey1}
        isSidebarVisible={isSidebarVisible}
        setIsSidebarVisible={setIsSidebarVisible}
      />
      <div
        id="main-content"
        style={{
          // 'padding-top': '30px',
          // 'padding-bottom': '12px',
          // 'padding-left': '10px',
          // 'padding-right': '10px',
          width: !isSidebarVisible ? 'calc(100% - 250px)' : 'calc(100% - 80px)',
          transition: 'width 0.3s ease-in-out',
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  isLoggedin: loginReducer.isLoggedin,
});

export default connect(mapStateToProps)(App);
